/**
 * @generated SignedSource<<a1ab3fb0fa82fb123d0ca2cc5bb0ca4e>>
 * @relayHash 2253487d96d1a31aed7d36a48896412d
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 2253487d96d1a31aed7d36a48896412d

import { ConcreteRequest } from 'relay-runtime';
export type AssociationType = "MANDATORY" | "OPTIONAL";
export type AsynchronousQuestionnaireUsage = "ACCEPTED" | "ALL" | "DECLINED";
export type Country = "CH" | "DE";
export type Language = "ENGLISH" | "FRENCH" | "GERMAN" | "ITALIAN";
export type UpdatePersonalTreatmentPlanTemplateInput = {
  amountOfDays?: number | null;
  asynchronousQuestionnaireUsage?: AsynchronousQuestionnaireUsage | null;
  countries: ReadonlyArray<Country>;
  diagnosisCodes: ReadonlyArray<string>;
  id: string;
  languages: ReadonlyArray<TreatmentPlanTemplateLanguageInput>;
  name: string;
};
export type TreatmentPlanTemplateLanguageInput = {
  followUpInstructions?: string | null;
  language: Language;
  recommendedTreatment?: string | null;
  synonym?: string | null;
  title: string;
};
export type useUpdatePersonalTreatmentPlanTemplateMutation$variables = {
  input: UpdatePersonalTreatmentPlanTemplateInput;
};
export type useUpdatePersonalTreatmentPlanTemplateMutation$data = {
  readonly updatePersonalTreatmentPlanTemplate: {
    readonly errors: ReadonlyArray<{
      readonly message?: string;
    }> | null;
    readonly treatmentPlanTemplate: {
      readonly countries: ReadonlyArray<Country>;
      readonly icdDiagnoses: ReadonlyArray<{
        readonly associationType: AssociationType | null;
        readonly diagnosisCode: string;
        readonly id: string;
        readonly isAssociation: boolean;
        readonly primaryCode: string | null;
        readonly secondaryCode: string | null;
        readonly text: string;
      }>;
      readonly id: string;
      readonly languages: ReadonlyArray<{
        readonly followUpInstructions: string | null;
        readonly language: Language;
        readonly recommendedTreatment: string | null;
        readonly synonym: string | null;
        readonly title: string;
      }>;
      readonly name: string;
    } | null;
  };
};
export type useUpdatePersonalTreatmentPlanTemplateMutation = {
  response: useUpdatePersonalTreatmentPlanTemplateMutation$data;
  variables: useUpdatePersonalTreatmentPlanTemplateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "TreatmentPlanTemplate",
  "kind": "LinkedField",
  "name": "treatmentPlanTemplate",
  "plural": false,
  "selections": [
    (v2/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "countries",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "TreatmentPlanTemplateLanguage",
      "kind": "LinkedField",
      "name": "languages",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "language",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "title",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "followUpInstructions",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "synonym",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "recommendedTreatment",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "IcdDiagnosis",
      "kind": "LinkedField",
      "name": "icdDiagnoses",
      "plural": true,
      "selections": [
        (v2/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isAssociation",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "diagnosisCode",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "primaryCode",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "secondaryCode",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "associationType",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "text",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v4 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "message",
      "storageKey": null
    }
  ],
  "type": "Error",
  "abstractKey": "__isError"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useUpdatePersonalTreatmentPlanTemplateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "UpdatePersonalTreatmentPlanTemplatePayload",
        "kind": "LinkedField",
        "name": "updatePersonalTreatmentPlanTemplate",
        "plural": false,
        "selections": [
          (v3/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v4/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "useUpdatePersonalTreatmentPlanTemplateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "UpdatePersonalTreatmentPlanTemplatePayload",
        "kind": "LinkedField",
        "name": "updatePersonalTreatmentPlanTemplate",
        "plural": false,
        "selections": [
          (v3/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v4/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "2253487d96d1a31aed7d36a48896412d",
    "metadata": {},
    "name": "useUpdatePersonalTreatmentPlanTemplateMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "cf12621800d07622c258df010aba03b5";

export default node;
